<template>
  <div class="inline-flex gap-4">
    <a
      v-for="some in somes"
      :key="some.code"
      :href="some.url"
      :title="some.name"
      rel="noopener"
      target="_blank"
      class="rounded-full leading-0 p-2 hover:bg-amaranth"
      v-bind="$attrs"
    >
      <component :is="some.code+'-icon'" size="1x" />
    </a>
  </div>
</template>

<script>
import {
  InstagramIcon, PinterestIcon, YoutubeIcon, FacebookIcon
} from '@bit/vekenkaluste.veke-ui.icons'

const allowedCodes = [
  'facebook',
  'instagram',
  'pinterest',
  'youtube'
]

export default {
  name: 'SocialMediaLinks',
  components: {
    InstagramIcon, PinterestIcon, YoutubeIcon, FacebookIcon
  },
  props: {
    content: {
      type: Array,
      required: true,
      default: () => ([])
    }
  },
  computed: {
    somes () {
      return Object.keys(this.content).length ? this.content.filter(item => allowedCodes.includes(item.code)) : []
    }
  }
}
</script>
